export default __webpack_public_path__ + "static/media/tm.ff36ff32.png";